import { textDecoration } from "@chakra-ui/react"

export default {
    parts: ['container', 'step', 'circle', 'checkIcon', 'stepNumber', 'label'],
    baseStyle: (props) => {
        const {isActive, isCompleted, isClickable} = props || {}
        return {
            container: {
                alignItems: 'flex-start',
                justifyContent: 'center',
                gap: '12px',
                minW: {base: '180px', md: '280px'}
            },
            step: {
                flexDirection: 'column',
                alignItems: 'center',
                gap: '6px',
                minW: '90px',
                minH: '49px',
                cursor: isClickable ? 'pointer' : 'default'
            },
            circle: {
                w: '24px',
                h: '24px',
                borderRadius: 'full',
                alignItems: 'center',
                justifyContent: 'center',
                bg: isCompleted || isActive ? 'webTheme.backgroundReverse' : 'webTheme.backgroundPrimaryBrand',
                border: '1.5px solid',
                borderColor: isCompleted || isActive ? 'webTheme.backgroundReverse' : 'webTheme.backgroundPrimaryBrand',
                flexShrink: 0
            },
            checkIcon: {
                w: '12px',
                h: '12px'
            },
            stepNumber: {
                textStyle: 'labelXs',
                color: isActive ? 'webTypo.textPrimaryReverse' : 'webTypo.textPrimary'
            },
            label: {
                textStyle: 'bodyXsSRegular',
                whiteSpace: 'nowrap',
                _hover: {
                    textDecoration: isCompleted ? 'underline' : 'none'
                }
            }
        }
    }
}
